<template>
  <g-chart type="ColumnChart" :settings="settings" :data="data" :options="merged_options" />
</template>

<script>
  import { GChart } from 'vue-google-charts';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import cloneDeep from 'lodash-es/cloneDeep';
  export default {
    components: {
      GChart
    },
    props: {
      data: {
        type: [Array, Object],
        default: () => []
      },
      options: {
        type: Object,
        default: () => ({})
      },
      settings: {
        type: Object,
        default: () => ({
          packages: ['corechart', 'bar']
        })
      }
    },
    computed: {
      merged_options() {
        if (this.options) {
          return defaultsDeep(cloneDeep(this.options), this.default_options);
        }
        return this.default_options;
      },
      default_options() {
        return {
          width: '100%',
          height: 400,
          legend: { position: 'bottom' },
          bar: { groupWidth: '75%' },
          chartArea: { width: '100%', height: '100%', top: '45', bottom: '105' },
          isStacked: true,
          vAxis: {
            format: '0'
          },
          animation: { duration: 500, easing: 'inAndOut', startup: true }
        };
      }
    }
  };
</script>
